import './main'

/**
 * Riscontro visivo sull'allegato.
 *
 * Il markup usa le classi del componente Upload di UIkit (.js-upload, #js-progressbar)
 * ma UIkit.upload non e' mai stato inizializzato: selezionando un file non cambiava
 * nulla a schermo e l'utente non poteva sapere se il caricamento fosse avvenuto.
 * Qui elenchiamo i file scelti sotto la zona di upload e avvisiamo se sono troppo
 * pesanti per il webhook.
 */
document.addEventListener('DOMContentLoaded', () => {
    const zona = document.querySelector('.js-upload')
    const input = zona && zona.querySelector('input[type="file"]')
    if (!input) return

    const LIMITE_MB = 8

    const elenco = document.createElement('div')
    elenco.className = 'file-scelti uk-margin-small-top'
    zona.appendChild(elenco)

    const avviso = document.createElement('div')
    avviso.className = 'file-avviso uk-margin-small-top'
    avviso.style.color = '#c0392b'
    zona.appendChild(avviso)

    const disegna = () => {
        elenco.textContent = ''
        avviso.textContent = ''

        const files = Array.from(input.files || [])
        if (!files.length) return

        let totale = 0
        files.forEach((f) => {
            totale += f.size
            const riga = document.createElement('div')
            // textContent, non innerHTML: il nome del file arriva dall'utente
            riga.textContent = '✓ ' + f.name + '  (' + Math.max(1, Math.round(f.size / 1024)) + ' KB)'
            elenco.appendChild(riga)
        })

        const totaleMB = totale / (1024 * 1024)
        if (totaleMB > LIMITE_MB) {
            avviso.textContent =
                'Gli allegati pesano ' + totaleMB.toFixed(1) + ' MB: oltre ' + LIMITE_MB +
                ' MB l’invio puo’ non andare a buon fine. Meglio inviarli via e-mail a info@hasofir.com.'
        }
    }

    input.addEventListener('change', disegna)

    // dopo un invio riuscito il form viene resettato: va riallineato anche l'elenco
    const form = input.closest('form')
    if (form) form.addEventListener('reset', () => setTimeout(disegna, 0))
})
